export const sampleTitle = 'This is an example title'
export const sampleDescription = 'This is an example description'
export const sampleTo = 'email@example.com'
export const sampleSubject = 'This is an example subject'
export const sampleMessage = 'My name is {name} and I am from {location}, this is an example email message.'
